import { filter } from 'rxjs/operators';
import { CrewRatingsChartComponent } from './crew-ratings-chart/crew-ratings-chart.component';
import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { AnalyticsService } from 'src/app/services/analytics.service';
import { AppSpinnerService } from 'src/app/services/app-spinner.service';

import { AppConstant } from 'src/app/utilities/app.constants';
import html2canvas from 'html2canvas'; 
import * as jspdf from 'jspdf';  
import { FilterService } from 'src/app/services/filter.service';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { CrewDataService } from 'src/app/services/crew-data.service';
import { SettingsService } from 'src/app/services/settings.service'
import { CustomDialogService } from 'src/app/shared/custom-dialog.service';

import { of, timer } from 'rxjs';
import { debounce } from 'rxjs/operators';
@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss']
})
export class AnalyticsComponent implements OnInit, OnDestroy {
  @ViewChild('chartView', { static: false }) chartView: ElementRef;
  @ViewChild('crewRatingsChart', { static: false }) crewRatingsComp: CrewRatingsChartComponent;
  intialRatings: any = [];
  allRatings: any;
  filteredRatings: any = [];
  questionsAvgRatings: any = [];
  period = 'Last 1 Month';
  outlier = false;
  firm = 'all';
  showListView = true;
  filteredDataArray = [];
  filterStatusForPage = true;
  filterServiceSubscription: Subscription;
  multiSelected : any = {};
  sameListSelected = 0;
  selectedFilters: any;
  chartName = 'Line Chart'
  constructor(
    private readonly analyticsService: AnalyticsService,
    public appSpinner: AppSpinnerService,
    private readonly filterService: FilterService,
    public crewService: CrewDataService,
    public settingsService: SettingsService, 
    public datepipe: DatePipe,
    public customerDialogService: CustomDialogService) {
      this.filterService.analyticsSubject.subscribe((data: any) =>{
        this.showListView = data;
      })

      this.settingsService.getSubmitterDetailViewStatus().subscribe((data : any) => {
        console.log('Settings1 ',data);
        if(data){
          this.settingsService.setEmailAddress(data.submitterEmailAddressArray);
        }
      })
     }

  ngOnInit() {
    console.log('test');
    this.fetchAllRatings("all",false);
    this.filterServiceSubscription = this.filterService.filterPoolSubject.pipe(debounce(() => timer(1000))).subscribe(filterPool => {
      console.log('this.filterServiceSubscription-');
      //if (!this.showListView) {
        const filterData = this.prepareFilterData(filterPool);
        this.selectedFilters = filterData;
        this.filterAllRatingByFilterPool(this.intialRatings);
        this.fetchRatingsByFilter(filterData);
      const initialFilterData = { 
        firm: "all",
        nationality: [
           "Philippines (the)"
        ],
        rank: [],
        ageGroup: [],
        department: undefined,
        category: undefined,
        outlier: false
      }
        this.fetchQuestionsAvgRatings(initialFilterData);
      //}
    });
  }

  prepareFilterData(filterData: any[]) {
    let filterObj: any = { 
      firm: "all",
      nationality: [],
      rank: [],
      ageGroup: [],
      department: undefined,
      category: undefined,
      outlier: false
    };

    filterData.forEach(item => {
       if (item.option === 'firm') {
        filterObj.firm = item.name
       } else if (item.option === 'nation') {
        filterObj.nationality.push(item.name);
       } else if (item.option === 'period') {
        filterObj.period = item.name
       } else if (item.option === 'department') {
        filterObj.department = item.name
       } else if (item.option === 'category') {
        filterObj.category = item.name
       } else if (item.option === 'rank') {
        filterObj.rank.push(item.name);
       } else if (item.option === 'age') {
        filterObj.ageGroup.push(item.name);
       } else if (item.option === 'outlier') {
         filterObj.outlier = item.name;
       }
     });
     
     this.multiSelected = {};
     if (filterObj.nationality.length > 1) {
      this.multiSelected.key = 'nationality';
      this.multiSelected.values = filterObj.nationality;
    } else if (filterObj.rank.length > 1) {
     this.multiSelected.key = 'rank';
     this.multiSelected.values = filterObj.rank;
    } else if (filterObj.ageGroup.length > 1) {
     this.multiSelected.key = 'ageGroup';
     this.multiSelected.values = filterObj.ageGroup;
    } else if (filterObj.nationality.length === 1) {
      this.multiSelected.key = 'nationality';
      this.multiSelected.values = filterObj.nationality;
    } else if (filterObj.rank.length === 1) {
     this.multiSelected.key = 'rank';
     this.multiSelected.values = filterObj.rank;
    } else if (filterObj.ageGroup.length === 1) {
     this.multiSelected.key = 'ageGroup';
     this.multiSelected.values = filterObj.ageGroup;
    }

     filterObj.nationality = filterObj.nationality.length ? filterObj.nationality : undefined;
     filterObj.rank = filterObj.rank.length ? filterObj.rank : undefined;
     filterObj.ageGroup = filterObj.ageGroup.length ? filterObj.ageGroup : undefined;
     
     // console.clear();
     console.log('multiSelected===', filterObj);

     return filterObj;
  }

  filterAllRatingByFilterPool(baseRatings: any[]) {
    this.allRatings = [...baseRatings];
    console.log('data list ',this.allRatings);
    
    if (this.selectedFilters.firm && this.selectedFilters.firm !== 'all') {
      this.allRatings = this.allRatings.filter((rating: any) => {
          return this.selectedFilters.firm === rating.vesselInfo.manager
      });
    }

    if (this.selectedFilters.category) {
      this.allRatings = this.allRatings.filter((rating: any) => {
          return this.selectedFilters.category === rating.userInfo.category
      });
    }

    if (this.selectedFilters.department) {
      this.allRatings = this.allRatings.filter((rating: any) => {
        return this.selectedFilters.department === rating.userInfo.department
      });
    }

    if (this.selectedFilters.rank) {
      this.allRatings = this.allRatings.filter((rating: any) => {
        return this.selectedFilters.rank.indexOf(rating.userInfo.rank) > -1;
      });
    }

    if (this.selectedFilters.ageGroup) {
      this.allRatings = this.allRatings.filter((rating: any) => {
        return this.selectedFilters.ageGroup.indexOf(rating.userInfo.ageGroup) > -1;
      });
    }

    if (this.selectedFilters.nationality) {
      this.allRatings = this.allRatings.filter((rating: any) => {
        return this.selectedFilters.nationality.indexOf(rating.userInfo.nationality) > -1;
      });
    }

    console.log('filter pool=', this.selectedFilters);
  }

  fetchAllRatings(firm:string,outlier: boolean) {
    this.appSpinner.show();
    this.analyticsService.getAllRatingsData(this.period,firm,outlier).subscribe((allRatings: any[]) => {
      this.intialRatings = [...allRatings];
      this.allRatings = allRatings;
      this.appSpinner.hide();
    });
  }

  fetchRatingsByFilter(filters: any) {
    this.appSpinner.show();
    this.analyticsService.getRatingsByFilter(filters).subscribe((filteredRatings: any[]) => {
      this.filteredRatings = filteredRatings;
      this.appSpinner.hide();
      // this.crewRatingsComp.prepareDataForLineAndBarCharts();
    });
  }

  fetchQuestionsAvgRatings(filters: any) {
    this.appSpinner.show();
    this.analyticsService.getQuestionAvgRating(filters).subscribe((avgRatings: any[]) => {
      this.questionsAvgRatings = avgRatings;
      console.log('questionsAvgRatings ',this.questionsAvgRatings);
      this.appSpinner.hide();
    });
  }


  removeFilterType(filterType: any,name: any){
    this.allRatings = this.allRatings.filter((data: any) =>{
      if (data.userInfo) {
        console.log('removing ',data.userInfo[filterType].toLowerCase().indexOf(name.toLowerCase()));
        console.log('rm data ',data.userInfo);
        return data.userInfo[filterType].toLowerCase().indexOf(name.toLowerCase()) < 0;
       } else {
         return false;
       }
    });
    if(this.allRatings.length == 0){
      this.allRatings = [...this.intialRatings];
      this.filteredDataArray = [];
    }
  }


  checkOutlier(event){
    this.outlier = event;
    console.log('analytics outlier ', event);
    this.analyticsService.getAllRatingsData(this.period, this.firm, this.outlier).subscribe((allRatings: any[]) => {
      this.intialRatings = [...allRatings];
      this.allRatings = allRatings;
    });
  }

  nameFilter(event: any) {
    const name = event.event;
    if (this.intialRatings && this.intialRatings.length) {
      this.allRatings = this.intialRatings.filter( rating => {
         const fullName = `${rating.userInfo.firstName} ${rating.userInfo.anotherName}`;
         return fullName.toLowerCase().indexOf(name.toLowerCase()) > -1;
      });
    }
    this.filterAllRatingByFilterPool(this.allRatings);
  }

  crewIdFilter(event: any) {
    const crewId = event.event;
    if (this.intialRatings && this.intialRatings.length) {
      this.allRatings = this.intialRatings.filter( rating => {
         if (rating.userInfo) {
          return rating.userInfo.crewId.toLowerCase().indexOf(crewId.toLowerCase()) > -1;
         }
      });
    }
    this.filterAllRatingByFilterPool(this.allRatings);
  }

  periodFilter(event: any) {
    this.period = event.event;
    this.analyticsService.getAllRatingsData(this.period, this.firm, this.outlier).subscribe((allRatings: any[]) => {
      this.intialRatings = [...allRatings];
      this.allRatings = allRatings;
      this.filterAllRatingByFilterPool(this.intialRatings);
    });
  }

  
  firmFilter(event: any) {
    this.firm = event.event;
    // if(event.option){
    //   if(event.status == 'renew'){
    //     this.filteredDataArray = [];
    //     this.allRatings = [];
    //     let listdata = [...new Set([...this.filterFirmListData('manager', event.name)])];
    //     this.filteredDataArray = listdata;
    //     this.allRatings = listdata;
    //   }
    //   else if(event.status == 'selected'){
    //     console.log('selected');
    //     let listdata : any;
    //     listdata = [...new Set([...this.filteredDataArray,...this.filterFirmListData('manager', event.name)])];
    //     this.filteredDataArray = listdata;
    //     this.allRatings = listdata;
    //   }
    //   else{
    //     event.option = 'firm';
    //     this.removeSelectedFirmList('manager',event.name,this.allRatings);
    //   }
    // }
    // if(event.operation == '1'){
    //   const firm = event.event;
    //   let listdata = [...new Set([...this.filterFirmListDataFromSelectedCollection('manager', firm)])];
    //   this.filteredDataArray = listdata;
    //   this.allRatings = listdata;
    // }
    // else{
    //   const firm = event.event;
    //   console.log('firm ',firm);
    //   if(firm !=='Select Firm'){
    //     let listdata = [...new Set([...this.filteredDataArray ,...this.filterFirmListData('manager', firm)])];
    //     this.filteredDataArray = listdata;
    //     this.allRatings = listdata;
    //   }
    //   else if(firm ==='Select Firm'){
    //     this.fetchAllRatings("all",false);
    //   }
    // }
   
  }



  filterList(key: string, value: string) {
    if (this.intialRatings && this.intialRatings.length) {
      this.allRatings = this.intialRatings.filter( rating => {
         if (rating.userInfo) {
          return rating.userInfo[key].toLowerCase().indexOf(value.toLowerCase()) > -1;
         } else {
           return false;
         }
      });
    }
  }


  // removeSelectedList(key: string, value,selectedList: any) {
  //   if (selectedList && selectedList.length) {
  //     this.allRatings = selectedList.filter( rating => {
  //        if (rating.userInfo) {
  //          console.log('rm data '+key+"  "+value  ,rating.userInfo[key]);
  //         return rating.userInfo[key].toLowerCase().indexOf(value.toLowerCase()) < 0;
  //        } else {
  //          return false;
  //        }
  //     });
  //     if(this.allRatings.length == 0){
  //       this.allRatings = [...this.intialRatings];
  //       this.filteredDataArray = [];
  //     }
  //   }
  // }


  

  removeSelectedList(key: string, value,selectedList: any) {
    if (selectedList && selectedList.length) {
      console.log('rm check array', selectedList);
      let tempArray : any = [];
      for(let index = 0;index <selectedList.length; index++){
        let userInfoKey = selectedList[index].userInfo[key].toLowerCase();
        console.log('rm check data ', userInfoKey);
        if(selectedList[index].userInfo[key].toLowerCase() != value.toLowerCase()){
          tempArray.push(selectedList[index]);
        }
      }
      this.allRatings = tempArray;
      console.log('list ', this.allRatings);
      if(this.allRatings.length == 0){
        this.allRatings = [...this.intialRatings];
        this.filteredDataArray = [];
      }
    }
  }

  removeSelectedFirmList(key: string, value,selectedList: any) {
    if (selectedList && selectedList.length) {
      console.log('rm check array', selectedList);
      let tempArray : any = [];
      for(let index = 0;index <selectedList.length; index++){
        let vesselInfoKey = selectedList[index].vesselInfo[key].toLowerCase();
        console.log('rm check data ', vesselInfoKey);
        if(selectedList[index].vesselInfo[key].toLowerCase() != value.toLowerCase()){
          tempArray.push(selectedList[index]);
        }
      }
      this.allRatings = tempArray;
      console.log('list ', this.allRatings);
      if(this.allRatings.length == 0){
        this.allRatings = [...this.intialRatings];
        this.filteredDataArray = [];
      }
    }
  }

  


  // filterListData(key: string, value: string) {
  //     if (this.intialRatings && this.intialRatings.length) {
  //       this.allRatings = this.intialRatings.filter( rating => {
  //        if (rating.userInfo) {
  //          console.log('userdata ', rating.userInfo[key].toLowerCase().indexOf(value.toLowerCase()));
  //         return rating.userInfo[key].toLowerCase().indexOf(value.toLowerCase()) > -1;
  //        } else {
  //          return false;
  //        }
  //     });
  //    return this.allRatings;
  //   }
    
  // }

  filterListData(key: string, value) {
    console.log('data check ', key ,value);
    console.log('init data ',this.intialRatings);
    if (value != undefined) {
      let tempArray : any = [];
      for(let index = 0;index<this.intialRatings.length;index++){
        let userInfoKey = this.intialRatings[index].userInfo[key].toLowerCase();
        console.log('rm check data ', userInfoKey);
        if(this.intialRatings[index].userInfo[key].toLowerCase() == value.toLowerCase()){
          tempArray.push(this.intialRatings[index]);
        }
      }
      this.allRatings = tempArray; 
      console.log('test ',this.allRatings); 
      return this.allRatings;
  }
  
}

filterFirmListData(key: string, value) {
  console.log('data check ', key ,value);
  console.log('init data ',this.intialRatings);
  if (value != undefined) {
    let tempArray : any = [];
    for(let index = 0;index<this.intialRatings.length;index++){
      let vesselInfoKey = this.intialRatings[index].vesselInfo[key].toLowerCase();
      console.log('rm check data ', vesselInfoKey);
      if(this.intialRatings[index].vesselInfo[key].toLowerCase() == value.toLowerCase()){
        tempArray.push(this.intialRatings[index]);
      }
    }
    this.allRatings = tempArray; 
    console.log('test ',this.allRatings); 
    return this.allRatings;
}

}

//   filterListDataFromSelectedCollection(key: string, value: string) {
//     if (this.allRatings && this.allRatings.length) {
//       this.allRatings = this.allRatings.filter( rating => {
//        if (rating.userInfo) {
//          console.log('age ', rating.userInfo[key]);
//         return rating.userInfo[key].toLowerCase().indexOf(value.toLowerCase()) > -1;
//        } else {
//          return false;
//        }
//     });
//     console.log('inner data filtered ', this.allRatings);
//    return this.allRatings;
//   }
  
// }

    filterListDataFromSelectedCollection(key: string, value) {
      if (this.allRatings && this.allRatings.length) {
        let tempArray : any = [];
        for(let index = 0;index<this.allRatings.length;index++){
          let userInfoKey = this.allRatings[index].userInfo[key].toLowerCase();
          console.log('rm check data ', userInfoKey);
          if(this.allRatings[index].userInfo[key].toLowerCase() == value.toLowerCase()){
            tempArray.push(this.allRatings[index]);
          }
        }
        this.allRatings = tempArray; 
        console.log('test ',this.allRatings);
        return this.allRatings; 
    }
  }

  filterFirmListDataFromSelectedCollection(key: string, value) {
    if (this.allRatings && this.allRatings.length) {
      let tempArray : any = [];
      for(let index = 0;index<this.allRatings.length;index++){
        let vesselInfoKey = this.allRatings[index].vesselInfo[key].toLowerCase();
        console.log('rm check data ', vesselInfoKey);
        if(this.allRatings[index].vesselInfo[key].toLowerCase() == value.toLowerCase()){
          tempArray.push(this.allRatings[index]);
        }
      }
      this.allRatings = tempArray; 
      console.log('test ',this.allRatings);
      return this.allRatings; 
  }
}

  setViewType(event) {
    console.log('view type', event);
    this.showListView = event;
  }

  setChartName(event) {
    if(event == 'barChart') {
      this.chartName = 'Bar Chart'
    } else if (event == 'paretoChart') {
      this.chartName = 'Pareto Chart'
    }
  }

  PDFgeneration() {
    if (!this.showListView) {
      const content = this.chartView.nativeElement;
      html2canvas(content).then(canvas => {
        // Few necessary setting options  
        var imgWidth = 200;
        var pageHeight = 400;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/png')

        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF  
        var position = 40;
        pdf.addImage(contentDataURL, 'PNG', 5, position, imgWidth, 100);
        pdf.setFontSize(13);
        this.addHeaderAndFooter(pdf);
        this.addRatingDescription(pdf);        //method for adding ratings description on PDF
        pdf.save('Crew-List-ChartView.pdf'); // Generated PDF   
      });
    }
  }

  addHeaderAndFooter(pdfObject) {
    var number_of_pages = pdfObject.internal.getNumberOfPages();
    var pdf_pages = pdfObject.internal.pages;
    var report_name = 'Analytics - '+ this.chartName;
    const todayDate = new Date();
    const date = this.datepipe.transform(todayDate, 'dd/MM/yyyy');
    for (var i = 1; i < pdf_pages.length; i++) {
      // We are telling our pdfObject that we are now working on this page
      pdfObject.setPage(i);
      pdfObject.text(date,175, 270);
      pdfObject.setFontType('bold');
      pdfObject.text('Analytics',175, 15);
      pdfObject.text(report_name,80,30);
			//pdfObject.text('Safety Rating :',162,60);
      pdfObject.text(AppConstant.HEADER_TEXT,22, 15);
      pdfObject.text('Downloaded on Date:', 127, 270);
      pdfObject.addImage(AppConstant.IMG_HEADER, 'png', 5, 7, 15, 15);
      pdfObject.addImage(AppConstant.IMG_FOOTER, 'png', 5, 280, 60, 15);
      pdfObject.text('Page ' + i + '/' + number_of_pages, 
      pdfObject.internal.pageSize.getWidth() - 30, pdfObject.internal.pageSize.getHeight() - 10);
    }
  }

  addRatingDescription(pdfObject) {
    var number_of_pages = pdfObject.internal.getNumberOfPages();
    var pdf_pages = pdfObject.internal.pages;
    for (var i = 1; i < pdf_pages.length; i++) {
      if (i == number_of_pages) {
        pdfObject.setFontSize(10)
        pdfObject.setFontType('unbold');
        pdfObject.text(' Unsatisfied', 10, 155);
        pdfObject.text(' Needs Improvements', 10, 160);
        pdfObject.text(' Meets Expectations', 10, 165);
        pdfObject.text(' Exceeds Expectations', 10, 170);
        pdfObject.text(' Exceptional', 10, 175);
        pdfObject.setFontType('bold');
        pdfObject.text('Rating Scale:-', 5, 150);
        pdfObject.text('1 :', 5, 155);
        pdfObject.text('2 :', 5, 160);
        pdfObject.text('3 :', 5, 165);
        pdfObject.text('4 :', 5, 170);
        pdfObject.text('5 :', 5, 175);
      }
    }
  }

  openMail() {
    if (!this.showListView) {
      const content = this.chartView.nativeElement;
      html2canvas(content).then(canvas => {
        // Few necessary setting options  
        var imgWidth = 200;
        var pageHeight = 400;
        var imgHeight = canvas.height * imgWidth / canvas.width;
        var heightLeft = imgHeight;

        const contentDataURL = canvas.toDataURL('image/png')

        let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF  
        var position = 40;
        pdf.addImage(contentDataURL, 'PNG', 5, position, imgWidth, 100);
        pdf.setFontSize(13);
        this.addHeaderAndFooter(pdf);
        this.addRatingDescription(pdf);
        //pdf.save('Crew-List-ChartView.pdf');
        const pdfBase64 = pdf.output('datauristring');
        this.customerDialogService.showDialog('Do you want to email the pdf file of this screen?','yes').subscribe(actionType => {
          console.log('actionType ',actionType);
          if(actionType === 'yes'){
            this.appSpinner.show();
            this.crewService.sendEmailToUser('Analytics_chartView.pdf', pdfBase64).subscribe((data:any)=>{
              if(data){
                console.log('sucessfull ',data);
                this.appSpinner.hide();
                this.customerDialogService.showDialog(data.message, 'dismiss');
              } 
            }); 
          }
          else{

          }
        })
      });
    }
  }

  ngOnDestroy() {
    if (this.filterServiceSubscription) {
      this.filterServiceSubscription.unsubscribe();
    }
  }
}
